import BotStore from '@src/store';
import CommonStore from '@src/stores/CommonStore';

export const listenToStores = [BotStore, CommonStore];

// import {saveGeneralNodes} from '@src/actions/BotActions';

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  return {
    domain: CommonStore.getMetaTags().domain,
    location: BotStore.getLocation(),
    generalNodes: BotStore.getGeneralNodes(),
    editedGeneralNodes: BotStore.getEditedGeneralNodes(),
    meta: CommonStore.getMetaTags(),
    supportedLanguages: CommonStore.getSupportedLanguages(),
    currentLanguage: CommonStore.getCurrentLanguage(),
    nodeContextMenuEnabled: BotStore.getEnableNodeContextMenuFlag(),
    isSelfServe: BotStore.getSelfServeLayout(),
  };
}

export {
  getGeneralNodes,
  clearGeneralNodes,
  saveGeneralNodes,
  createAlert,
  userHasPermission,
  permissionErrorAlert,
  showConfirmationDialog,
  openComponentModal,
} from '@src/actions/BotActions';
export { sendGoogleAnalyticsEvents } from '@src/actions/_utils';
export { updateCurrentLanguage } from '@src/actions/LanguageActions';
